import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "sess-grid" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = ["readonly", "placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "os-chips"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  style: {"font-size":"13px","color":"#a8a4a0"}
}
const _hoisted_8 = {
  key: 1,
  class: "os-proc-lbl"
}
const _hoisted_9 = {
  key: 3,
  style: {"max-height":"200px","overflow":"auto"}
}
const _hoisted_10 = { class: "os-chips" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"margin-top":"25px"} }
const _hoisted_13 = ["readonly", "placeholder"]
const _hoisted_14 = {
  key: 0,
  class: "panel"
}
const _hoisted_15 = { style: {"padding":"26px 12px 26px","text-align":"center","font-size":"14px"} }
const _hoisted_16 = {
  key: 0,
  style: {"margin-bottom":"15px"}
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "panel"
}
const _hoisted_19 = { class: "av" }
const _hoisted_20 = { class: "att-n" }
const _hoisted_21 = { style: {"color":"var(--dark-gray)"} }
const _hoisted_22 = {
  key: 0,
  class: "os-signed"
}
const _hoisted_23 = {
  key: 1,
  class: "os-practice"
}
const _hoisted_24 = {
  key: 2,
  style: {"font-size":"12px","color":"#a8a4a0"}
}
const _hoisted_25 = {
  key: 0,
  class: "os-seg"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  style: {"margin-top":"15px"}
}
const _hoisted_29 = {
  key: 2,
  class: "panel"
}
const _hoisted_30 = {
  key: 1,
  class: "pill p-done"
}
const _hoisted_31 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_32 = { class: "form-wrapper slide-up" }
const _hoisted_33 = { class: "form-close" }
const _hoisted_34 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { style: {"font-weight":"600"} }
const _hoisted_37 = { style: {"font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!

  return (_ctx.session)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _cache[16] || (_cache[16] = _createElementVNode("h4", null, "What we're reviewing", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "oc-notes",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.session.ReviewingText) = $event)),
                readonly: _ctx.readOnly,
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                placeholder: _ctx.readOnly ? '' : 'Describe what you\'re training on at the station — what you\'re reviewing with them.'
              }, null, 40, _hoisted_4), [
                [_vModelText, _ctx.session.ReviewingText]
              ]),
              (_ctx.readOnly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "os-proc-lbl" }, "Related processes", -1)),
                    (_ctx.attachedProcesses.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachedProcesses, (p, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: i,
                              type: "button",
                              class: "os-chip on",
                              onClick: ($event: any) => (_ctx.openProcess(p))
                            }, [
                              _createVNode(_component_svg_icon, { icon: "check" }),
                              _createTextVNode(_toDisplayString(p.Name), 1)
                            ], 8, _hoisted_6))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, "None"))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Related processes ", -1),
                    _createElementVNode("span", { style: {"font-weight":"normal"} }, "· optional", -1)
                  ]))])),
              (!_ctx.readOnly)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 2,
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.processSearchQ) = $event)),
                    placeholder: "Search processes",
                    style: {"width":"100%","margin":"0 0 10px"}
                  }, null, 512)), [
                    [_vModelText, _ctx.processSearchQ]
                  ])
                : _createCommentVNode("", true),
              (!_ctx.readOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProcessOptions, (p, i) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: i,
                          type: "button",
                          class: _normalizeClass('os-chip' + (_ctx.isProcessAttached(p) ? ' on' : '')),
                          onClick: ($event: any) => (_ctx.toggleProcess(p))
                        }, [
                          _createVNode(_component_svg_icon, {
                            icon: _ctx.isProcessAttached(p) ? 'check' : 'plus'
                          }, null, 8, ["icon"]),
                          _createTextVNode(_toDisplayString(p.Name), 1)
                        ], 10, _hoisted_11))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _cache[15] || (_cache[15] = _createElementVNode("h4", { style: {"margin-bottom":"6px"} }, "Notes", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "oc-notes",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.session.Notes) = $event)),
                  readonly: _ctx.readOnly,
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save())),
                  placeholder: _ctx.readOnly ? '' : 'How it went, what to revisit next time…'
                }, null, 40, _hoisted_13), [
                  [_vModelText, _ctx.session.Notes]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (!_ctx.traineesList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Trainees", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_svg_icon, {
                        icon: "twousers",
                        style: {"width":"48px","height":"48px"}
                      })
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { style: {"margin-bottom":"5px","font-size":"18px"} }, "No trainees yet.", -1)),
                    (!_ctx.readOnly)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Pick who's being trained at the station."))
                      : _createCommentVNode("", true),
                    (!_ctx.readOnly)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = () => { _ctx.showPicker = true }),
                            class: "btn-lg",
                            style: {"margin":"0"}
                          }, [
                            _createVNode(_component_svg_icon, {
                              icon: "twousers",
                              style: {"width":"14px","height":"14px"}
                            }),
                            _cache[17] || (_cache[17] = _createTextVNode("Select trainees", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("h4", null, [
                    _cache[20] || (_cache[20] = _createTextVNode("Trainees", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.signedOffCount) + "/" + _toDisplayString(_ctx.traineesList.length) + " signed off", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineesList, (t, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "att"
                    }, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(t.initials), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(t.name), 1),
                        (t.signoffStatus == 'Signed off')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_svg_icon, { icon: "check2" }),
                              _createTextVNode("Signed off by " + _toDisplayString(t.signedByName) + " · " + _toDisplayString(t.signedAtString), 1)
                            ]))
                          : (t.signoffStatus == 'Needs practice')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createVNode(_component_svg_icon, { icon: "alerttriangle" }),
                                _cache[21] || (_cache[21] = _createTextVNode("Needs more practice", -1))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_24, "Not signed off yet"))
                      ]),
                      (!_ctx.readOnly)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass('os-seg-btn' + (t.signoffStatus == 'Needs practice' ? ' prac' : '')),
                              onClick: ($event: any) => (_ctx.signoff(t, 'Needs practice'))
                            }, "Needs practice", 10, _hoisted_26),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass('os-seg-btn' + (t.signoffStatus == 'Signed off' ? ' sign' : '')),
                              onClick: ($event: any) => (_ctx.signoff(t, 'Signed off'))
                            }, [
                              _createVNode(_component_svg_icon, { icon: "check" }),
                              _cache[22] || (_cache[22] = _createTextVNode("Sign off", -1))
                            ], 10, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (!_ctx.readOnly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("a", {
                          onClick: _cache[6] || (_cache[6] = _withModifiers(() => { _ctx.showPicker = true }, ["prevent"])),
                          class: "primary",
                          style: {"text-decoration":"none!important"}
                        }, [
                          _createVNode(_component_svg_icon, {
                            icon: "adduser",
                            style: {"width":"14px","height":"14px"}
                          }),
                          _cache[23] || (_cache[23] = _createTextVNode("  Edit trainees", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (!_ctx.readOnly || _ctx.session.Status == 'Completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (_ctx.session.Status != 'Completed')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.markComplete())),
                        class: "btn-lg",
                        style: {"width":"100%","justify-content":"center"}
                      }, [
                        _createVNode(_component_svg_icon, {
                          icon: "check3",
                          style: {"width":"14px","height":"14px"}
                        }),
                        _cache[24] || (_cache[24] = _createTextVNode("Mark session complete", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, [
                        _createVNode(_component_svg_icon, { icon: "check2" }),
                        _cache[25] || (_cache[25] = _createTextVNode("Session Complete", -1))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.showPicker)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "form-close-x",
                    title: "Close",
                    onClick: _cache[8] || (_cache[8] = () => { _ctx.showPicker = false })
                  }, "×")
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Who's being trained?", -1)),
                _createElementVNode("div", null, [
                  _createTextVNode("Select everyone being trained" + _toDisplayString(_ctx.session.Station ? ' at ' : ''), 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.session.Station), 1),
                  _cache[26] || (_cache[26] = _createTextVNode(". They'll be signed off individually as they're ready.", -1))
                ]),
                _withDirectives(_createElementVNode("input", {
                  style: {"margin-top":"15px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employeeSearchQ) = $event)),
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterEmployees())),
                  placeholder: "Search employees"
                }, null, 544), [
                  [_vModelText, _ctx.employeeSearchQ]
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      style: {"margin-bottom":"5px"},
                      class: "checkbox-input"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((e.checked) = $event)
                      }, null, 8, _hoisted_35), [
                        [_vModelCheckbox, e.checked]
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(e.Name) + " · ", 1),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(e.SeatTitle), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  style: {"margin-top":"25px","width":"100%"},
                  class: _normalizeClass(_ctx.disableButton ? 'btn-lg disable-button' : 'btn-lg'),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submitPicker()))
                }, "Done", 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.viewProcess)
          ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
              key: 1,
              url: _ctx.processSlug,
              onClose: _cache[12] || (_cache[12] = () => _ctx.viewProcess = false)
            }, null, 8, ["url"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}